import { NgModule, Type } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { HomePageModule } from 'src/app/@pages/home/home.page.module';
import { MainPageModule } from 'src/app/@pages/main/main.page.module';

export const PUBLIC_ROUTES: Routes = [
  {
    // landing route for redirected legacy nakos.de address links; its guard always redirects
    loadChildren: (): Promise<Routes> => {
      return import('src/app/organization/@shared/legacy-address.routes').then((mod) => {
        return mod.LEGACY_ADDRESS_ROUTES;
      });
    },
    path: 'addresses/:legacyId',
  },
  {
    loadChildren: (): Promise<Type<HomePageModule>> => {
      return import('src/app/@pages/home/home.page.module').then((mod) => {
        return mod.HomePageModule;
      });
    },
    path: 'home',
  },
  {
    loadChildren: (): Promise<Type<MainPageModule>> => {
      return import('./@pages/main/main.page.module').then((mod) => { return mod.MainPageModule; });
    },
    path: 'main',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(PUBLIC_ROUTES, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
})
export class AppRoutingModule {}
